import { useState, useEffect } from "react";
import MotoristaService from "../../services/resource/motoristaService";
import DropDown from "../../components/dropdown/dropdown";
import InputForm from "../../components/input/input";
import ButtonLoading from "../../components/buttonLoading/buttonLoading";
import InputFormMask from "../../components/inputMask/inputMask";

const initialValues = {
  id: '',
  name: '',
  branchId: ''
};

function MotoristaUpdate({ motorista, branches, setShowModal, onChange }) {
  const [form, setForm] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadMotorista = async () => {

      const id = motorista.id.toString().substring(4);
      setForm({
        id: id,
        name: motorista.name || '',
        branchId: motorista.branchId || ''
      })

    }
    loadMotorista();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await new MotoristaService().update(motorista.id, form);
      setShowModal(false);
      onChange()
    } catch (err) {
      setError(err.response?.data?.message || "Erro ao atualizar motorista.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <InputFormMask
            type="text"
            name="id"
            placeholder="Código"
            value={form.id}
            disabled={true}
            onChange={handleChange}
            label="Código do motorista"
          />
        </div>
        <div>
          <InputForm
            type="text"
            name="name"
            placeholder="Nome do motorista"
            value={form.name}
            label="Nome do motorista"
            onChange={handleChange}
          />
        </div>
        <div>
          <DropDown
            id="updateBranchId"
            label="Filial"
            label1="name"
            optionValue="id"
            optionLabel="name"
            optionIcon="image"
            name="branchId"
            disabled={loading}
            value={form.branchId}
            options={branches}
            onChange={handleChange}
          />
        </div>
      </div>

      {error && <p className="text-red-600 mt-2">{error}</p>}
      <div className="flex justify-end space-x-3 mt-4">
        <ButtonLoading
          id="cancel-update"
          type="text"
          color="gray"
          label="Cancelar"
          optional
          onClick={() => setShowModal(false)}
        />
        <ButtonLoading
          type="submit"
          label="Atualizar motorista"
          color="blue"
          id="confirm-update"
          loading={loading}
        />
      </div>
    </form>
  );
}

export default MotoristaUpdate;
